import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { APPS, appForPath } from '../utils/storeLinks';

// Safari's Smart App Banner (iOS/iPadOS). One per page, chosen from the route:
// Crowns pages → Crowns, Binary Sudoku pages → Binary Sudoku+, other
// puzzle pages → Daily Logic Puzzles, everything else → Crowns.
function SmartAppBanner() {
  const { pathname } = useLocation();
  const app = APPS[appForPath(pathname)];
  return (
    <Helmet>
      <meta name="apple-itunes-app" content={`app-id=${app.iosId}`} />
    </Helmet>
  );
}

export default SmartAppBanner;
